export default __webpack_public_path__ + "static/media/principal-transparent.a71c0f40.svg";